module.exports = __webpack_public_path__ + "img/birdT.ed310906.png";